import React, { useState } from 'react';
import { ErrorMessage, connect as withFormikConnect, FormikBag } from 'formik';
import { DateRangePickerInput } from '@honeyguide/components';

import { BookingNotAvailableModal } from '../../../components';

import { formatForApi } from '../../../lib/helpers';
import { isStartDateInvalid } from '../../../lib/utils';

import '@honeyguide/components/dist/components/DateRangePicker/Calendar.css';

type Props = {
  placeholder: string,
  formik: FormikBag,
};

function LodgeDateRangePicker(props: Props) {
  const { formik } = props;
  const { values, setFieldValue } = formik;
  const { checkinDate, checkoutDate } = values;

  const [showMessage, setShowMessage] = useState(false);
  const openMessage = () => setShowMessage(true);
  const closeMessage = () => setShowMessage(false);

  const setCheckinDate = date => setFieldValue('checkinDate', formatForApi(date));
  const setCheckoutDate = date => setFieldValue('checkoutDate', formatForApi(date));

  return (
    <React.Fragment>
      <BookingNotAvailableModal
        isOpen={showMessage}
        close={closeMessage}
      />
      <DateRangePickerInput
        initialStartDate={checkinDate}
        initialEndDate={checkoutDate}
        inputProps={{
          placeholder: 'Checkin - Checkout Date',
        }}
        initialShowStartDateText="Select your checkin date"
        initialShowEndDateText="Select your checkout date"
        onApply={(startDate, endDate) => { 
          if (isStartDateInvalid(startDate)) {
            return openMessage();
          } else {
            setCheckinDate(startDate);
            setCheckoutDate(endDate);
          }
        }}
      />
      <ErrorMessage name="checkin">
        {error => (error ? <p className="error">{error}</p> : null)}
      </ErrorMessage>
    </React.Fragment>
  );
}

export default withFormikConnect(LodgeDateRangePicker);



// WEBPACK FOOTER //
// ./src/screens/Lodge/Common/LodgeDateRangePicker.js